// Leads page ke tabs (All / New / Calling / Qualified).
//
// Active tab ka "folder tab" wala shape ek alag element hai (.indicator) jo
// chune hue tab ke neeche slide karta hai — isliye tab badalne par shape
// kood kar nahi, sarak kar jaata hai. Uski jagah aur chaudai button ko naap
// kar nikalti hai, kyunki har tab ka text (aur ginti) alag lamba hota hai.
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import styles from "./PounceLeadsTabs.module.css";

const PounceLeadsTabs = ({ tabs, active, onChange }) => {
  const scrollerRef = useRef(null);
  const buttonRefs = useRef({});
  const [box, setBox] = useState(null); // { x, width } — active button ki jagah

  const measure = useCallback(() => {
    const el = buttonRefs.current[active];
    if (!el) return;
    const next = { x: el.offsetLeft, width: el.offsetWidth };
    // Wahi value dobara set na ho — warna har render ek naya render chhedta.
    setBox((prev) => (prev && prev.x === next.x && prev.width === next.width ? prev : next));
  }, [active]);

  // Labels me ginti hoti hai ("All (24)"), jo data aane par badalti hai aur
  // button ki chaudai badal deti hai. `tabs` har render naya array hai, isliye
  // dependency me uski jagah labels ki ek string.
  const labelsKey = tabs.map((t) => t.label).join("|");
  useLayoutEffect(() => {
    measure();
  }, [measure, labelsKey]);

  // Screen ghoomne / font load hone par chaudai badalti hai.
  useEffect(() => {
    window.addEventListener("resize", measure);
    document.fonts?.ready?.then(measure).catch(() => {});
    return () => window.removeEventListener("resize", measure);
  }, [measure]);

  // Chhote phone pe tabs scroll hote hain — chuna hua tab nazar me rahe.
  useEffect(() => {
    buttonRefs.current[active]?.scrollIntoView({
      behavior: "smooth",
      inline: "nearest",
      block: "nearest",
    });
  }, [active]);

  return (
    <div className={styles.wrap}>
      <div className={styles.scroller} ref={scrollerRef} role="tablist" aria-label="Lead status">
        {box && (
          <span
            className={styles.indicator}
            aria-hidden="true"
            // Naapi hui values — CSS variables se, baaki sab module CSS me.
            style={{ "--tab-x": `${box.x}px`, "--tab-w": `${box.width}px` }}
          >
            <span className={styles.indicatorMask} />
          </span>
        )}

        {tabs.map((tab) => {
          const selected = tab.key === active;
          return (
            <button
              key={tab.key}
              ref={(el) => {
                buttonRefs.current[tab.key] = el;
              }}
              type="button"
              role="tab"
              aria-selected={selected}
              className={`${styles.tab} ${selected ? styles.tabActive : ""}`}
              // data-label: CSS isi se bold text ki chaudai pehle se reserve
              // karta hai, taaki chunne par tab chauda ho kar baaki ko na dhakele.
              data-label={tab.label}
              onClick={() => onChange(tab.key)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PounceLeadsTabs;
